import React, { useState } from "react";
import { Box, Typography, Paper } from "@mui/material";
import { History } from "@mui/icons-material";

import AdminLogsTable, { createData } from "./table";
import { Data } from "./table/tableHeadCells";
import { IAdminLogsParams } from "@/api/types/admin-logs";
import AdminLogsFilters, { defaultValues } from "./filters";
import { useUserList } from "@/api/hooks/useUsers";
import { useAdminLogs } from "@/api/hooks/useAdminLogs";

const AdminLogs: React.FC = () => {
    const [params, setParams] = useState<IAdminLogsParams>({
        skip: 0,
        take: 10,
        search: "",
        filter: {},
    });

    // Get all admin users for filter dropdown
    const { data: usersData } = useUserList({
        search: "",
        skip: 0,
        take: 1000, // Get all users
        filter: {
            role: null,
            active: null,
            emailVerified: null,
        },
    });

    const { data: logsData, isFetching, isLoading } = useAdminLogs(params);

    const users =
        usersData?.data.items.map((user) => ({
            id: user.id,
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
        })) || [];

    const logs = logsData?.data.items.map(createData) || [];
    const totalItems = logsData?.data.pagination.totalItems || 0;

    const handleApply = (data: typeof defaultValues) => {
        console.log("handleApply called with:", data);
        setParams((prev) => {
            // Create filter object with only non-empty values
            const filterObject: any = {};
            if (data.entity) filterObject.entity = data.entity;
            if (data.action) filterObject.action = data.action;
            if (data.userId) filterObject.userId = data.userId;
            if (data.startDate) filterObject.startDate = data.startDate;
            if (data.endDate) filterObject.endDate = data.endDate;

            const newParams = {
                ...prev,
                search: data.search || "",
                filter: filterObject,
            };
            console.log("New params:", newParams);
            return newParams;
        });
    };

    const handleChange = ({ page, rowsPerPage }: { page?: number, rowsPerPage?: number }) => {
        setParams((prev) => {
            return {
                ...prev,
                skip: Number(page) * Number(rowsPerPage),
                take: rowsPerPage || 10,
            };
        });
    };

    return (
        <Box sx={{ p: 3 }}>
            <Paper sx={{ p: 3, mb: 3 }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <History sx={{ mr: 2, color: "primary.main" }} />
                    <Typography variant="h5" component="h1">
                        Admin History
                    </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                    View all changes made to the system, including who made each change and when.
                </Typography>
            </Paper>

            <AdminLogsFilters onApply={handleApply} users={users} />

            <AdminLogsTable
                data={logs}
                totalItems={totalItems}
                rowsPerPage={params.take || 10}
                page={Number(params.skip) / Number(params.take || 10)}
                onChange={handleChange}
                isLoading={isLoading}
                isFetching={isFetching}
                isPending={false}
            />
        </Box>
    );
};

export default AdminLogs;
